import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { LangText } from '@/components'
import { useNavigate, useLocation } from 'react-router-dom'
import { Form } from 'antd'
import useModel from './useModel'
import classNames from 'classnames'
import { preFixImgUrl } from '@/utils'
import Protocol from '@/components/Protocol'
import SignWays from './components/SignWays'
import PhoneForm from './components/PhoneForm'
import EmailForm from './components/EmailForm'
import PasswordForm from './components/PasswordForm'

type LocationState = { account?: string; type?: 'phone' | 'email' } | null

const SignUp = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();
  const location = useLocation();
  const { step, accountInfo, activeSignInType, setActiveSignInType, form, isButtonDisabled, handleSubmit, ...modelMethods } = useModel()
  const navigate = useNavigate()

  useEffect(() => {
    const state = location.state as LocationState;
    if (state?.account && state?.type && (state.type === 'phone' || state.type === 'email')) {
      setActiveSignInType(state.type);
      form.setFieldsValue({ [state.type]: state.account });
    }
  }, []);

  return (
    <div className='bg-[#F8F6FF] min-h-screen flex flex-col items-center justify-center leading-[1.5]'>
      <div className='flex justify-between items-center px-10 mx-auto w-8xl'>
        <div className='flex flex-col items-center'>
          <LangText lngKey='36bbc3e4' className='text-[32px] font-bold'>{t('36bbc3e4')}</LangText>
          <img src={preFixImgUrl('2f0f6b5973281e61d695cfde30a02bcc.png')} className='w-[576px] h-[451px] mt-[27px]' />
        </div>
        {step === 1 ? (
          <div className='w-[486px] min-h-[580px] px-[38px] bg-white rounded-[12px] shadow-[0px_8px_18px_0px_rgba(18,37,196,0.06)] py-10 flex flex-col justify-start'>
            <LangText lngKey='7a19c71b' className='text-[24px] font-bold '>{t('7a19c71b')}</LangText>
            <LangText lngKey='44849aa6' className='text-[16px] text-[#666666] font-normal  mt-[4px]'>{t('44849aa6')}</LangText>
            <SignWays value={activeSignInType} onChange={setActiveSignInType} />
            <Form form={form} layout="vertical" className='!mt-4 leading-[1.5]' onFinish={handleSubmit}>
              {
                activeSignInType === 'phone' && <PhoneForm form={form} {...modelMethods} />
              }
              {
                activeSignInType === 'email' && <EmailForm form={form} {...modelMethods} />
              }
              <div className='mt-[26px]'>
                <Form.Item
                  name='protocol'
                  noStyle
                  rules={[
                    {
                      validator: (_, value) =>
                        value === true ? Promise.resolve() : Promise.reject(new Error(t('55a0f085')))
                    }
                  ]}
                >
                  <Protocol />
                </Form.Item>
              </div>
              <button
                type='submit'
                className={classNames(`w-full mt-3 rounded-[24px] bg-linear-to-r from-[#a75aff] to-[#4b51ff] h-[44px]`, {
                  'opacity-60': isButtonDisabled,
                  'cursor-not-allowed': isButtonDisabled,
                  'cursor-pointer': !isButtonDisabled,
                })}
                disabled={isButtonDisabled}
              >
                <LangText lngKey='9489f21d' className='text-[15px] text-white'>{t('9489f21d')}</LangText>
              </button>
              <div className='flex justify-center items-center mt-4'>
                <LangText lngKey='5080845a' className='text-[14px]'>{t('5080845a')}</LangText>
                &nbsp;
                <LangText onClick={() => navigate('/signin', { replace: true })} lngKey='cb5d1a1c' className='text-[14px] text-[#5a52ff] cursor-pointer'>{t('cb5d1a1c')}</LangText>
              </div>
            </Form>

          </div>
        ) : (
          <PasswordForm
            accountInfo={accountInfo}
            {...modelMethods}
          />
        )}
      </div>
      <span className='text-[12px] text-[#666666] absolute bottom-10'>© {year} JapanDX. All rights reserved.</span>
    </div>
  )
}
export default SignUp